<ng-template #content><ng-content /></ng-template>
